import Image from "next/image";
import { Center } from "@chakra-ui/react";
import OemArchitecture from "public/oemConverged/OEM-Architecture.png";

const OemArchitectureImg = () => {
  return (
    <Center>
      <Image
        src={OemArchitecture}
        alt="Oem Converged Architecture"
        style={{ height: "auto", maxWidth: "800px", width: "100%" }}
      />
    </Center>
  );
};

export default OemArchitectureImg;
